/**
 * About.js
 * 
 * The about page component.
 */

import React from "react";

const About = () => {
    return (
        <div className="page">
            <h1 className="mt-20 text-4xl text-white">About Me</h1>
            <p>Jald hi btata hun</p>
        </div>
    );
};

export default About;